import type { ReactNode } from 'react';
import { useTenantsApi } from '../../lib/api/context.js';
import { telHref } from './labels.js';

/** «Позвонить» и «Написать» — ссылки `tel:` и `mailto:`. Перед переходом в
 *  журнал уходит отметка; ответа звонок не ждёт. */
export function CallLink({
  tenantId,
  phone,
  children,
  className,
  label,
}: {
  tenantId: string;
  phone: string;
  children: ReactNode;
  className: string;
  label?: string;
}) {
  const api = useTenantsApi();
  return (
    <a
      href={telHref(phone)}
      aria-label={label}
      className={className}
      onClick={(event) => {
        event.stopPropagation();
        api.contact(tenantId, { channel: 'phone', target: phone });
      }}
    >
      {children}
    </a>
  );
}

export function MailLink({
  tenantId,
  email,
  children,
  className,
}: {
  tenantId: string;
  email: string;
  children: ReactNode;
  className: string;
}) {
  const api = useTenantsApi();
  return (
    <a
      href={`mailto:${email}`}
      className={className}
      onClick={() => {
        api.contact(tenantId, { channel: 'email', target: email });
      }}
    >
      {children}
    </a>
  );
}
